<template>
  <div>
    <v-dialog v-model="show" max-width="500" :persistent="true">
      <v-card>
        <v-card-title class="headline">{{$t('components.dialog.companySelect.title')}}</v-card-title>

        <v-card-text>
          <v-select
            :label="$t('components.dialog.companySelect.label')"
            :items="userStore.companies"
            item-text="name"
            item-value="id"
            v-model="model"
            return-object
          ></v-select>
        </v-card-text>

        <v-card-actions class="pr-4 pb-3">
          <v-spacer></v-spacer>

          <v-btn color="primary" class="black--text" :disabled="!isCompanySelected()" @click="done()"> {{$t('common.continue')}} </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapStores } from 'pinia';
import { useUserStore } from '../../stores/UserStore';

export default {
  props: {
    visible: Boolean,
  },

  model: {
    prop: 'visible',
    event: 'update',
  },

  data() {
    return {
      model: {},
    };
  },

  computed: {
    ...mapStores(useUserStore),

    show: {
      get: function () {
        return this.visible;
      },
      set: function (value) {
        this.$emit('update', value);

        if (value === false) {
          this.$emit('close');
        }
      },
    },
  },

  methods: {
    done() {
      this.userStore.setSelectedCompany(this.model);
      this.close();
    },

    close() {
      this.clearFields();
      this.show = false;
    },

    clearFields() {
      this.model = {};
    },

    isCompanySelected() {
      return this.model && !!this.model.id;
    },
  },
};
</script>
